import { createReducers, createActions, request } from '../../../utils/';
import { combineReducers } from 'redux';
import Urls from '../../../../config/index';
import { message } from 'antd';
import _ from 'lodash';
import moment from 'moment';
const { clientUrl, clientMangeUrl } = Urls;

const path = name => `app/pages/client/${name}`;
let listOfTranker;
const models = {
    list: {
        data: [],
        handlers: {
            get(state, action) {
                return action.payload;
            },
            add(state, action) {
                return [...action.payload, ...state];
            },
            del(state, action) {
                return state.filter(item => item._id !== action.payload);
            },
            update(state, action) {
                return state.map(item => (item._id === action.payload._id ? action.payload : item));
            },
        },
    },
    listAppv: {
        data: [],
        handlers: {
            getAppv(state, action) {
                return action.payload;
            },
        },
    },
    APPList:{
        data: [],
        handlers: {
            getAPPList(state, action) {
                return action.payload;
            },
        },
    },
    listAll: {
        data: [],
        handlers: {
            getAll(state, action) {
                return action.payload;
            },
        },
    },
    listAllChild: {
        data: [],
        handlers: {
            getlistAllChild(state, action) {
                return action.payload;
            },
        },
    },
    transferData: {
        data: {
            selectedRowKeys: [],
        },
        handlers: {
            getTransferData(state, action) {
                return {...state, ...action.payload};
            },
        },
    },
    transferDataApp: {
        data: {
            selectedRowKeysApp:[],
        },
        handlers: {
            getTransferDataApp(state, action) {
                return {...state, ...action.payload};
            },
        },
    },
    pagination: {
        data: {
            current: 1,
            total: 0,
            pageSize: 10,
        },
        handlers: {
            changePagination(state, action) {
                return {
                    ...state,
                    ...action.payload,
                };
            },
        },
    },
    searchValues: {
        data: {},
        handlers: {
            changeSearchValues(state, action) {
                return action.payload;
            },
        },
    },
    uiStatus: {
        data: {
            isLoading: false,
            isUpdateShow: false,
            isSendCommend: false,
            isSetGroupShow: false,
            isUpdateVersionLoading: false,
            udpateVersionShow:false,
            udpateAppListShow:false,
            isUpdateAppListLoading:false,
            isAPPListLoading:false,
        },
        handlers: {
            changeUiStatus(state, action) {
                return {
                    ...state,
                    ...action.payload,
                };
            },
        },
    },
    currentSelectId: {
        data: '',
        handlers: {
            changeCurrentSelectId(state, action) {
                return action.payload;
            },
        },
    },
};




export const actions = createActions(models, path);

export default combineReducers(createReducers(models, path));

const formatGetParams = getState => {
    const state = getState().clientList;
    const searchValue = state.searchValues || {};

    const params = {
        ...searchValue,
        page: state.pagination.current,
        pageSize: state.pagination.pageSize,
    };
    return params;
};

export const asyncGetAPPList = () => {
    return async (dispatch, getState) => {
        try {
            dispatch(
                actions.changeUiStatus({
                    isAPPListLoading: true,
                }),
            );
            // 下面的请求和结果返回需要根据接口来实现
            let result = await request(clientUrl.getAllAppList, 'POST');
            result = result.map(item => {
                item.key = item.id;
                return item;
            });
            dispatch(actions.getAPPList(result));
        } catch (e) {
            throw e;
        } finally {
            dispatch(
                actions.changeUiStatus({
                    isAPPListLoading: false,
                }),
            );
        }
    };
};

//批量更新targetVersion

export const updateTargetVersion = (params) => {
    return async (dispatch, getState) => {
        try {
            dispatch(
                actions.changeUiStatus({
                    isUpdateVersionLoading: true,
                }),
            );
            // 下面的请求和结果返回需要根据接口来实现
           await request(clientUrl.updateBatchVersion, 'POST', params);

        } catch (e) {
            throw e;
        } finally {
            dispatch(
                actions.changeUiStatus({
                    isUpdateVersionLoading: false,
                }),
            );
        }
    };
};
//批量更新AppList

export const updateAppList = (params) => {
    return async (dispatch, getState) => {
        try {
            dispatch(
                actions.changeUiStatus({
                    isUpdateAppListLoading: true,
                }),
            );
            // 下面的请求和结果返回需要根据接口来实现
            await request(clientUrl.updateBatchList, 'POST', params);

        } catch (e) {
            throw e;
        } finally {
            dispatch(
                actions.changeUiStatus({
                    isUpdateAppListLoading: false,
                }),
            );
        }
    };
};

//批量更新AllAppList
export const updateAllAppList = (params) => {
    return async (dispatch, getState) => {
        try {
            dispatch(
                actions.changeUiStatus({
                    isUpdateAppListLoading: true,
                }),
            );
            // 下面的请求和结果返回需要根据接口来实现
            await request(clientUrl.updateAppList, 'POST', params);

        } catch (e) {
            throw e;
        } finally {
            dispatch(
                actions.changeUiStatus({
                    isUpdateAppListLoading: false,
                }),
            );
        }
    };
};
/**
 * 获取appv
 */
export const asyncGetAppv = () => {
    return async (dispatch, getState) => {
        try {

            // 下面的请求和结果返回需要根据接口来实现
            let result = await request(clientUrl.getAppv, 'POST');

            dispatch(actions.getAppv(result));
        } catch (e) {
            throw e;
        } finally {

        }
    };
};
export const updateAllTargetVersion = (params) => {
    return async (dispatch, getState) => {
        try {
            dispatch(
                actions.changeUiStatus({
                    isUpdateVersionLoading: true,
                }),
            );
            // 下面的请求和结果返回需要根据接口来实现
            await request(clientUrl.updateAllBatchVersion, 'POST', params);

        } catch (e) {
            throw e;
        } finally {
            dispatch(
                actions.changeUiStatus({
                    isUpdateVersionLoading: false,
                }),
            );
        }
    };
};
/**
 * 获取订单列表数据
 */
export const asyncGet = () => {
    return async (dispatch, getState) => {
        try {
            dispatch(
                actions.changeUiStatus({
                    isLoading: true,
                }),
            );
            // 下面的请求和结果返回需要根据接口来实现
            let result = await request(clientUrl.getClientList, 'POST', formatGetParams(getState));
            let { list } = result;
            list = list.map(item => {
                item.key = item.clientId;
                return item;
            });
            dispatch(actions.get(list));
            dispatch(actions.changePagination({total: result.total}));
        } catch (e) {
            throw e;
        } finally {
            dispatch(
                actions.changeUiStatus({
                    isLoading: false,
                }),
            );
        }
    };
};
export const changeTrankerSource = (onLineC,osC) => {
    return async (dispatch, getState) => {

        if (!onLineC && !osC) {
            dispatch(actions.getlistAllChild(listOfTranker));
            return;
        }

        let listall = listOfTranker;
        let listAllChild = new Array();
        for (let i = 0; i < listall.length; i++) {
            let flag1 = 0;
            let flag2 =0 ;
            let child = listall[i];
            if ((!onLineC || onLineC=="-1") || child.onLine == onLineC) {
                flag1 = 1;
            }
            if ((!osC || osC=="-1") || child.os == osC) {
                flag2 = 1;
            }
            if (flag1 == 1&&flag2 == 1) {

                listAllChild.push(listall[i]);
            }
        }
        dispatch(actions.getlistAllChild(listAllChild));
    };
};
export const asyncGetAll = () => {
    return async (dispatch, getState) => {
        try {
            dispatch(
                actions.changeUiStatus({
                    isLoading: true,
                }),
            );
            // 下面的请求和结果返回需要根据接口来实现
            let result = await request(clientUrl.getClientList, 'POST', {});
            let { list } = result;
            list = list.map(item => {
                item.key = item.clientId;
                return item;
            });
            listOfTranker = [...list];
            dispatch(actions.getlistAllChild(listOfTranker));
        } catch (e) {
            throw e;
        } finally {
            dispatch(
                actions.changeUiStatus({
                    isLoading: false,
                }),
            );
        }
    };
};
// 重启
export const reStart = params => {
    return async (dispatch, getState) => {
        try {
            await request(clientUrl.restartClient, 'POST', params);
            message.success('操作成功');
        } catch (e) {
            throw new Error(e);
        }
    };
};

export const asyncUpdate = content => {
    return async (dispatch, getState) => {
        try {
            dispatch(actions.changeUiStatus({ isLoading: true }));
            // 下面的请求和结果返回需要根据接口来实现
            await request(clientUrl.setClient, 'POST', content);
            message.success('修改成功');
            dispatch(actions.changeUiStatus({isUpdateShow: false}));
            // 下面的请求和结果返回需要根据接口来实现
            let result = await request(clientUrl.getClientList, 'POST', formatGetParams(getState));
            if (result) {
                dispatch(actions.get(result.list));
                dispatch(actions.changePagination({total: result.total}));
            }
        } catch (e) {
            throw e;
        } finally {
            dispatch(actions.changeUiStatus({ isLoading: false }));
        }
    };
};

export const asyncSetGroup = content => {
    return async (dispatch, getState) => {
        try {
            dispatch(actions.changeUiStatus({ isLoading: true }));
            await request(clientMangeUrl.addGroupInfo, 'POST', content);
        } catch (e) {
            throw e;
        } finally {
            dispatch(actions.changeUiStatus({ isLoading: false }));
        }
    };
};

export const deleteALL = content => {
    return async (dispatch, getState) => {
        try {
            dispatch(actions.changeUiStatus({ isLoading: true }));
            await request(clientUrl.deleteBatchAppClient, 'POST', content);
        } catch (e) {
            throw e;
        } finally {
            dispatch(actions.changeUiStatus({ isLoading: false }));
        }
    };
};



// WEBPACK FOOTER //
// ./pages/client/clientList/reducers.js